import { useCallback, useState } from 'react';
import { useSnackbar } from 'app/hooks/useSnackbar';
import { TPayoutReceipt } from 'modules/products/interfaces/multiSplitPayments';
import { MultiSplitPaymentsHttpService } from '../api/multiSplitPaymentsHttpService';

const useMultiSplitPaymentsService = () => {
  const { showSnackbar } = useSnackbar();
  const [isGetApplicationReceiptsLoading, setIsGetApplicationReceiptsLoading] =
    useState(false);
  const [isDownloadReceiptLoading, setIsDownloadReceiptLoading] =
    useState(false);

  const getApplicationReceipts = useCallback(
    async (applicationId: string): Promise<TPayoutReceipt[]> => {
      try {
        setIsGetApplicationReceiptsLoading(true);
        const multiSplitPaymentsService = new MultiSplitPaymentsHttpService();
        multiSplitPaymentsService.setHeader({
          handled: true,
        });
        const res = await multiSplitPaymentsService.getApplicationReceipts(
          applicationId,
        );

        return (res?.receipts || []).filter((receipt) => receipt.payout_id);
      } catch (error) {
        console.error('Erro getApplicationReceipts:', error);
        return [];
      } finally {
        setIsGetApplicationReceiptsLoading(false);
      }
    },
    [],
  );

  const getReceiptPdf = useCallback(
    async (payoutId: string): Promise<ArrayBuffer | null> => {
      try {
        setIsDownloadReceiptLoading(true);
        const multiSplitPaymentsService = new MultiSplitPaymentsHttpService();
        multiSplitPaymentsService.setRequestConfig({
          responseType: 'arraybuffer',
          headers: {
            handled: true,
          },
        });
        const result = await multiSplitPaymentsService.getReceiptPdf(payoutId);
        return result;
      } catch (error) {
        console.error('Erro getReceiptPdf:', error);
        showSnackbar(
          'Não foi possível baixar o comprovante de desembolso. Tente novamente.',
        );
        return null;
      } finally {
        setIsDownloadReceiptLoading(false);
      }
    },
    [showSnackbar],
  );

  return {
    isGetApplicationReceiptsLoading,
    isDownloadReceiptLoading,
    getApplicationReceipts,
    getReceiptPdf,
  };
};

export default useMultiSplitPaymentsService;
